import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { getApiUrl } from '../config/api';

const LeaseListPage = () => {
  const [leases, setLeases] = useState([]);

  useEffect(() => {
    // Get user_id from localStorage
    const user_id = localStorage.getItem('user_id');
    
    fetch(getApiUrl(`/api/v1/lease/list?user_id=${user_id}`))
      .then(res => res.json())
      .then(data => setLeases(data));
  }, []);

  const activeLeases = leases.filter(l => l.status !== 'signed');
  const signedLeases = leases.filter(l => l.status === 'signed');

  const renderLeaseCard = (lease) => (
    <div key={lease.lease_id} className="border rounded p-4 mb-2 shadow-sm bg-white">
      <div className="font-semibold">{lease.property_name}</div>
      <div>{lease.property_address}</div>
      <div>Tenant: {lease.tenant_name}</div>
      <div>Status: {lease.status}</div>
      <div>Start Date: {lease.start_date} - End Date: {lease.end_date}</div>
      <div className="mt-2">
        <Link to={`/lease/${lease.lease_id}`} className="text-green-600 underline">
          View Lease
        </Link>
      </div>
    </div>
  );

  return (
    <Layout pageTitle="Leases">
      <section className="dashboard-card summary-card">
        <h2>Active Leases</h2>
        {activeLeases.length > 0 ? activeLeases.map(renderLeaseCard) : <p>No active leases.</p>}
      </section>

      <section className="dashboard-card summary-card">
        <h2>Signed Leases</h2>
        {signedLeases.length > 0 ? signedLeases.map(renderLeaseCard) : <p>No signed leases.</p>}
      </section>
    </Layout>
  );
};

export default LeaseListPage;
